import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const ProgramsItem = (props) => {
    function formatScheduleText(data) {
        if (!data) return '';

        let text = `${data.days}${data.time}`.trim();

        text = text.replace(/^.*?(Segunda|Sábado|Domingo|Todos|24 e 31 de dezembro)/i, '$1');

        text = text
            .replace(/Segunda à Sexta/gi, 'Seg à Sex')
            .replace(/Sábado(s)?/gi, 'Sáb')
            .replace(/Domingo/gi, 'Dom')
            .replace(/Segunda à Domingo/gi, 'Seg à Dom')
            .replace(/Segunda a Domingo/gi, 'Seg à Dom')
            .replace(/Segunda à Dom/gi, 'Seg à Dom');

        text = text.replace(/(\d{1,2})h(\d{2})?/g, (_, hour, minute) => {
            const formattedHour = hour.padStart(2, '0');

            if (minute) {
                return `${formattedHour}h${minute}`;
            }

            return `${formattedHour}h`;
        });

        text = text.replace(/(de dezembro)(\d)/gi, '$1 $2');

        text = text.replace(/(Seg à Sex|Sáb|Dom|Todos os dias|São Paulo,\s*Seg-Sex|24 e 31 de dezembro)(\s*\d)/gi, '$1: $2');

        text = text.replace(/(Todos os dias)(A qualquer momento)/gi, '$1: $2');

        const horarios = text.match(/(\d{2}h\d{2}|\d{2}h)/g);

        if (horarios && horarios.length >= 3) {
            text = text
                .replace(/,\s*/g, ' | ')
                .replace(/\s+e\s+/g, ' | ');
        }

        return text;
    }

    return (
        <div className="containerProgram">
            <article>
                <header>
                    <h2>
                        {props.title}
                    </h2>
                    <figure>
                        <img alt={props.title} src={`https://a1media.antena1.com.br/image/programacao/${props.image}`} />
                    </figure>
                </header>
                <div className="containerP">
                    <p className="contentTx">
                        {props.resume}
                    </p>
                </div>
                <div className="containerDate">
                    <h6>DIAS E HORÁRIOS</h6>
                    <div className="dates">
                        <p>
                            {formatScheduleText(props)}
                        </p>
                    </div>
                </div>
            </article>
        </div>
    );
}

ProgramsItem.propTypes = exact({
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    resume: PropTypes.string.isRequired,
    // read via formatScheduleText(props) above, not directly - eslint can't trace that indirection
    /* eslint-disable react/no-unused-prop-types */
    days: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    /* eslint-enable react/no-unused-prop-types */
});

export default ProgramsItem;
